import { Container, Row, Col, Card, Button } from "react-bootstrap";
import { CheckCircle } from "lucide-react";

const GovEnterprise = () => {
  return (
    <main>

      {/* 🔥 HERO */}
      <section
        style={{
          backgroundImage:
            "linear-gradient(rgba(5,25,55,0.9), rgba(5,25,55,0.95)), url('https://images.pexels.com/photos/4386321/pexels-photo-4386321.jpeg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          color: "white",
          padding: "110px 0",
          textAlign: "center"
        }}
      >
        <Container>
          <h1 style={{ fontWeight: "700" }}>
            Government & Enterprise IT Solutions
          </h1>
          <p style={{ maxWidth: "750px", margin: "auto" }}>
            Secure, scalable, and compliant digital solutions for government
            departments, institutions, and large enterprises.
          </p>
        </Container>
      </section>

      {/* 🔹 INTRO */}
      <section className="gov-section">
        <Container>
          <Row className="align-items-center g-5">

            <Col lg={6}>
              <h2>Digital Transformation for Public & Enterprise Systems</h2>
              <p>
                We deliver reliable and secure IT solutions tailored for
                government bodies and enterprise organizations, focusing on
                compliance, scalability, and long-term sustainability.
              </p>

              <ul style={{ listStyle: "none", padding: 0 }}>
                {[
                  "GIGW-compliant platforms",
                  "Secure data management systems",
                  "Scalable enterprise architecture",
                  "High availability infrastructure"
                ].map((item, i) => (
                  <li key={i} className="d-flex gap-2 mb-2">
                    <CheckCircle size={18} color="green" />
                    {item}
                  </li>
                ))}
              </ul>
            </Col>

            <Col lg={6}>
              <img
                src="https://images.pexels.com/photos/3183150/pexels-photo-3183150.jpeg"
                alt="government"
                style={{ width: "100%", borderRadius: "12px" }}
              />
            </Col>

          </Row>
        </Container>
      </section>

      {/* 🔥 SOLUTIONS */}
      <section className="gov-section gov-section-alt">
        <Container>
          <h2 className="text-center mb-5">Our Solutions</h2>

          <Row className="g-4">

            {[
              {
                title: "E-Governance Systems",
                desc: "Digital platforms for citizen services and public administration."
              },
              {
                title: "Institutional ERP",
                desc: "ERP systems for schools, colleges, and universities."
              },
              {
                title: "Digital Portals",
                desc: "Government and enterprise web portals with high security."
              },
              {
                title: "Data Management Systems",
                desc: "Centralized data storage, analytics, and reporting systems."
              },
              {
                title: "Automation & Workflow Systems",
                desc: "Streamline operations through automated processes."
              },
              {
                title: "Cloud Infrastructure",
                desc: "Secure cloud-based infrastructure for scalability and performance."
              }
            ].map((item, i) => (
              <Col md={6} lg={4} key={i}>
                <Card className="gov-card p-4 h-100">
                  <h5>{item.title}</h5>
                  <p>{item.desc}</p>
                </Card>
              </Col>
            ))}

          </Row>
        </Container>
      </section>

      {/* 🔥 COMPLIANCE */}
      <section
        style={{
          backgroundImage:
            "linear-gradient(rgba(0,0,0,0.75), rgba(0,0,0,0.85)), url('https://images.pexels.com/photos/577585/pexels-photo-577585.jpeg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          color: "white",
          padding: "80px 0"
        }}
      >
        <Container>
          <h2 className="text-center mb-5">Compliance & Security</h2>

          <Row className="g-4 text-center">

            {[
              "GIGW Guidelines Compliance",
              "Data Privacy & Security Standards",
              "Role-based Access Control",
              "Audit & Logging Systems",
              "Secure API Integrations",
              "High Availability & Backup"
            ].map((item, i) => (
              <Col md={4} key={i}>
                <Card className="p-4 bg-dark text-white border-0 h-100">
                  <p>{item}</p>
                </Card>
              </Col>
            ))}

          </Row>
        </Container>
      </section>

      {/* 🔹 APPROACH */}
      <section className="gov-section">
        <Container>
          <h2 className="text-center mb-5">Our Implementation Approach</h2>

          <Row className="g-4 text-center">

            {[
              "Requirement Analysis",
              "Policy & Compliance Mapping",
              "System Design",
              "Development & Integration",
              "Testing & Deployment",
              "Training & Support"
            ].map((step, i) => (
              <Col md={4} key={i}>
                <Card className="gov-card p-4 h-100">
                  <h5>Step {i + 1}</h5>
                  <p>{step}</p>
                </Card>
              </Col>
            ))}

          </Row>
        </Container>
      </section>

      {/* 🔥 WHY IGT */}
      <section className="gov-section gov-section-alt">
        <Container>
          <h2 className="text-center mb-5">Why Choose IGT?</h2>

          <Row className="g-4">

            {[
              "Experience with institutional systems",
              "Security-first architecture",
              "Scalable enterprise solutions",
              "Compliance-focused development",
              "Reliable long-term support",
              "Modern technology stack"
            ].map((item, i) => (
              <Col md={4} key={i}>
                <Card className="gov-card p-4 text-center h-100">
                  <p>{item}</p>
                </Card>
              </Col>
            ))}

          </Row>
        </Container>
      </section>

      {/* 🔥 CTA */}
      <section
        style={{
          background: "linear-gradient(135deg, #0d3b66, #1d3557)",
          color: "white",
          padding: "80px 0",
          textAlign: "center"
        }}
      >
        <Container>
          <h2>Looking for Government or Enterprise Solutions?</h2>
          <p>Let’s build secure and scalable systems for your organization.</p>

          <Button href="/contact" size="lg" variant="light">
            Contact Us
          </Button>
        </Container>
      </section>

    </main>
  );
};

export default GovEnterprise;